import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { OkAloneService } from '../ok-alone.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  

  constructor(public okService:OkAloneService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!this.okService.isAdmin()){
      this.router.navigateByUrl('/home');
    }
    return this.okService.isAdmin();
    
  }
  
}
